import { createSlice } from "@reduxjs/toolkit";
import { emptyPatientOnj } from "@/utils/constants";
import { dateFormatter } from "@/utils/dateFormatter";

import { ISliceCreatePatient } from "@/shared/interfaces/patientPage";

const initialState: ISliceCreatePatient = {
    selectedPatient: emptyPatientOnj,
    patientId: "",
    appointments: [],
    dentalFormulas: [],
    isSelectedDefnalFormula: false,
    selectedDentalFormula: [],
    patientsBirthDay: dateFormatter(new Date()),
};

const patientsSlice = createSlice({
    name: "patients",
    initialState,
    reducers: {
        setPatientsData: (state, action) => {
            state.selectedPatient = action.payload;
            state.patientId = action.payload._id;
            state.dentalFormulas = action.payload.dentalFormulas;
            state.appointments = (action.payload.appointments || []).sort(
                (a: { date: string }, b: { date: string }) => {
                    const dateA = new Date(a.date);
                    const dateB = new Date(b.date);
                    return dateB.getTime() - dateA.getTime();
                },
            );
        },
        resetPatientsData: state => {
            state.selectedPatient = emptyPatientOnj;
            state.patientId = "";
            state.appointments = [];
            state.dentalFormulas = [];
        },
        setPatientId: (state, action) => {
            state.patientId = action.payload;
        },
        deleteAppointmentOnUserpage: (state, action) => {
            const newArr = state.appointments.filter(
                item => item._id !== action.payload,
            );
            state.appointments = [...newArr];
        },
        addDentalFormula: (state, action) => {
            state.dentalFormulas.unshift(action.payload);
        },
        setIsSelectedDentalFormula: (state, action) => {
            state.isSelectedDefnalFormula = action.payload;
        },
        setDataSelectedFormula: (state, action) => {
            const selectedFormula = state.dentalFormulas.filter(
                item => item._id === action.payload,
            );
            state.selectedDentalFormula = selectedFormula;
        },
        resetSelectedFormulaData: state => {
            state.isSelectedDefnalFormula = false;
            state.selectedDentalFormula = [];
        },
        addingPhotos: (state, action) => {
            const newArr = [
                action.payload,
                ...state.selectedPatient.patientPhotos,
            ];
            state.selectedPatient.patientPhotos = newArr;
        },
        deletePhotos: (state, action) => {
            const id = action.payload;
            const newArr = state.selectedPatient.patientPhotos.filter(
                item => item._id !== id,
            );
            state.selectedPatient.patientPhotos = newArr;
        },
        setPatientsBirthDay: (state, action) => {
            state.patientsBirthDay = action.payload;
        },
        updatePaymentHistory: (state, action) => {
            const { id, paymentHistory } = action.payload;

            state.appointments = state.appointments.map(appointment =>
                appointment._id === id
                    ? { ...appointment, paymentHistory: [...paymentHistory] }
                    : appointment,
            );
        },
    },
});

export const {
    setPatientsData,
    resetPatientsData,
    setPatientId,
    deleteAppointmentOnUserpage,
    addDentalFormula,
    setIsSelectedDentalFormula,
    setDataSelectedFormula,
    resetSelectedFormulaData,
    addingPhotos,
    deletePhotos,
    setPatientsBirthDay,
    updatePaymentHistory,
} = patientsSlice.actions;
export default patientsSlice.reducer;
